import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { AppUser } from './types'

export const CREATE_APP_USER: TypedDocumentNode<
  { createAppUser: AppUser },
  {
    applicationId: string
    username: string
    email: string
    password: string
    features?: string[]
    observations?: string | null
  }
> = gql`
  mutation CreateAppUser($applicationId: ID!, $username: String!, $email: String!, $password: String!, $features: [String!], $observations: String) {
    createAppUser(applicationId: $applicationId, username: $username, email: $email, password: $password, features: $features, observations: $observations) {
      id username email features observations created_at
    }
  }
`

export const UPDATE_APP_USER: TypedDocumentNode<
  { updateAppUser: AppUser },
  {
    id: string
    applicationId: string
    username?: string
    features?: string[]
    observations?: string | null
  }
> = gql`
  mutation UpdateAppUser($id: ID!, $applicationId: ID!, $username: String, $features: [String!], $observations: String) {
    updateAppUser(id: $id, applicationId: $applicationId, username: $username, features: $features, observations: $observations) {
      id username email features observations created_at
    }
  }
`

export const CREATE_ADMIN_USER: TypedDocumentNode<
  { createAdminUser: AppUser },
  { username: string; email: string; password: string; observations?: string | null }
> = gql`
  mutation CreateAdminUser($username: String!, $email: String!, $password: String!, $observations: String) {
    createAdminUser(username: $username, email: $email, password: $password, observations: $observations) {
      id username email features observations created_at
    }
  }
`

export const SET_USER_ADMIN: TypedDocumentNode<
  { setUserAdmin: AppUser },
  { id: string; isAdmin: boolean; username?: string; observations?: string | null }
> = gql`
  mutation SetUserAdmin($id: ID!, $isAdmin: Boolean!, $username: String, $observations: String) {
    setUserAdmin(id: $id, isAdmin: $isAdmin, username: $username, observations: $observations) {
      id username email features observations created_at
    }
  }
`

export const SET_USER_PASSWORD: TypedDocumentNode<
  { setUserPassword: boolean },
  { id: string; password: string }
> = gql`
  mutation SetUserPassword($id: ID!, $password: String!) {
    setUserPassword(id: $id, password: $password)
  }
`

export const DELETE_USER: TypedDocumentNode<{ deleteUser: boolean }, { id: string }> = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`

export const SEND_USER_ACTIVATION_EMAIL: TypedDocumentNode<
  { sendUserActivationEmail: boolean },
  { id: string }
> = gql`
  mutation SendUserActivationEmail($id: ID!) {
    sendUserActivationEmail(id: $id)
  }
`

export const REMOVE_USER_FROM_APP: TypedDocumentNode<
  { removeUserFromApp: boolean },
  { userId: string; applicationId: string }
> = gql`
  mutation RemoveUserFromApp($userId: ID!, $applicationId: ID!) {
    removeUserFromApp(userId: $userId, applicationId: $applicationId)
  }
`
